import { render } from "./Menu.vue?vue&type=template&id=c3f20698"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

import "./Menu.vue?vue&type=style&index=0&id=c3f20698&lang=css"
script.render = render

export default script